module.exports = __webpack_public_path__ + "static/media/06_us_temperature_map.a05a2a93.png";